import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gi-logo-image.png'


const _withScopeId = n => (_pushScopeId("data-v-50db59ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header",
  ref: "startLink"
}
const _hoisted_2 = { class: "brand-navigation" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "headers",
  href: "#about"
}, "About G.IO", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "headers",
  href: "#platform"
}, "Platform Services", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "headers",
  href: "#testimonials"
}, "Join Now", -1))
const _hoisted_6 = { style: {"background-color":"#130a23"} }
const _hoisted_7 = {
  id: "about",
  ref: "about",
  class: "about"
}
const _hoisted_8 = {
  id: "testimonials",
  ref: "testimonials",
  class: "testimonials"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "join-now" }, "Join Now", -1))
const _hoisted_10 = { class: "box-new-join" }
const _hoisted_11 = {
  key: 0,
  class: "p-d-flex p-justify-between"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"p-flex-column join-now-adjust\" data-v-50db59ca><span class=\"material-icons join-icons\" data-v-50db59ca>bar_chart</span><div class=\"percenteges\" data-v-50db59ca>20%</div><div class=\"join-title\" data-v-50db59ca>More Engagement</div><div class=\"join-text\" data-v-50db59ca> Micro-influencers tend to have a higher engagement rate than macro- influencers. </div><div class=\"join-text\" data-v-50db59ca> Access thousands of micro-communities with a 10 minute campaign set up. </div></div><div class=\"p-flex-column join-now-adjust\" data-v-50db59ca><span class=\"material-icons join-icons\" data-v-50db59ca>place</span><div class=\"percenteges\" data-v-50db59ca>75%</div><div class=\"join-title\" data-v-50db59ca>Brand Marketers</div><div class=\"join-text\" data-v-50db59ca>75% of Brand Marketers intend to dedicate more budget to influencer marketing in 2023 due to its effectiveness. </div></div><div class=\"p-flex-column join-now-adjust\" data-v-50db59ca><span class=\"material-icons join-icons\" data-v-50db59ca>people</span><div class=\"percenteges\" data-v-50db59ca>90%</div><div class=\"join-title\" data-v-50db59ca>Micro-Influencers</div><div class=\"join-text\" data-v-50db59ca> Micro-Influencers make up 90% of the influencer market. </div><div class=\"join-text\" data-v-50db59ca> With G.IO you have the power to access all of these untouched communities. </div></div>", 3)
const _hoisted_15 = [
  _hoisted_12
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"p-d-flex p-mt-2\" data-v-50db59ca><span class=\"material-icons join-icons\" data-v-50db59ca>bar_chart</span><div class=\"p-flex-column\" data-v-50db59ca><div class=\"percenteges\" data-v-50db59ca>20%</div><div class=\"p-flex-column p-mt-2\" data-v-50db59ca><div class=\"join-title\" data-v-50db59ca>More engagement</div><div class=\"join-text\" data-v-50db59ca>Micro-influencers tend to have a higher engagement rate than macro- influencers. </div><div class=\"join-text\" data-v-50db59ca> Access thousands of micro-communities with a 10 minute campaign set up. </div></div></div></div><div class=\"p-d-flex p-mt-2 p-mt-sm-5\" data-v-50db59ca><span class=\"material-icons join-icons\" data-v-50db59ca>place</span><div class=\"p-flex-column\" data-v-50db59ca><div class=\"percenteges\" data-v-50db59ca>75%</div><div class=\"p-flex-column p-mt-2\" data-v-50db59ca><div class=\"join-title\" data-v-50db59ca>Brand Marketers</div><div class=\"join-text\" data-v-50db59ca>75% of Brand Marketers intend to dedicate more budget to influencer marketing in 2023 due to its effectiveness. </div></div></div></div><div class=\"p-d-flex p-mt-2 p-mt-sm-5\" data-v-50db59ca><span class=\"material-icons join-icons\" data-v-50db59ca>place</span><div class=\"p-flex-column\" data-v-50db59ca><div class=\"percenteges\" data-v-50db59ca>90%</div><div class=\"p-flex-column p-mt-2\" data-v-50db59ca><div class=\"join-title\" data-v-50db59ca>Micro Influencers</div><div class=\"join-text\" data-v-50db59ca>Micro-Influencers make up 90% of the influencer market.</div><div class=\"join-text\" data-v-50db59ca> With G.IO you have the power to access all of these untouched communities </div></div></div></div>", 3)
const _hoisted_20 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sidebar_view = _resolveComponent("sidebar-view")!
  const _component_landing_header = _resolveComponent("landing-header")!
  const _component_sponsors_row = _resolveComponent("sponsors-row")!
  const _component_what_is_gio = _resolveComponent("what-is-gio")!
  const _component_platform_services = _resolveComponent("platform-services")!
  const _component_landing_footer = _resolveComponent("landing-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.scrollToComponent && $setup.scrollToComponent(...args)))
    }, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.scrollToTop($setup.startLink))),
        class: "logo-image",
        src: _imports_0
      }),
      _createElementVNode("ul", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("button", {
          class: "switch-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'influencer-view' })))
        }, "Switch To Influencer View"),
        _createElementVNode("button", {
          class: "login-button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'login' })))
        }, "Login / Register")
      ]),
      ($setup.isMobile)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.op = !$setup.op)),
            class: "material-icons menu-mobile"
          }, "menu"))
        : _createCommentVNode("", true),
      _createVNode(_component_sidebar_view, {
        view: 'brand',
        op: $setup.op,
        onClose: $setup.closeSidebar
      }, null, 8, ["op", "onClose"])
    ]),
    _createVNode(_component_landing_header, {
      view: 'brand',
      currentCampaign: $setup.currentCampaign
    }, null, 8, ["currentCampaign"]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_sponsors_row, { "is-mobile": $setup.isMobile }, null, 8, ["is-mobile"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_what_is_gio, {
        view: 'brand',
        "is-mobile": $setup.isMobile
      }, null, 8, ["is-mobile"])
    ], 512),
    _createVNode(_component_platform_services, {
      "is-mobile": $setup.isMobile,
      view: 'brand'
    }, null, 8, ["is-mobile"]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (!$setup.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_20))
      ]),
      _createElementVNode("div", {
        class: "join-btn",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'login' })))
      }, "JOIN NOW")
    ], 512),
    _createVNode(_component_landing_footer, {
      "is-mobile": $setup.isMobile,
      view: 'brand'
    }, null, 8, ["is-mobile"])
  ], 512))
}